class HeaderNav {
  constructor () {
    this.elNav = document.querySelector('nav.HNav__menu-container')
    this.elNavClose = document.querySelectorAll('.HNav__top-close')
    this.elProdArea = document.querySelector('.HNav__prod-right--list') // 右侧内容显示区
    this.elProdMenu = document.querySelectorAll('.HNav__prod-item')
    this.elProdSubmenu = document.querySelectorAll('.HNav__prod-sub-item')
    this.elProdSubmenuOther = document.querySelectorAll(
      '.HNav__prod-item[data-menu="other"]'
    )
    // 右侧所有产品[数组]
    this.elProdRight = []

    this.elMenuMb = document.querySelector('.HNav__menu--mb')
    this.elMenuOpen = document.querySelector('.HNav__menu-icon-open')
    this.elMenuClose = document.querySelector('.HNav__menu-icon-close')

    this.elToggleLabel = document.querySelectorAll('.HNav__toggle-label')

    // 默认显示子项
    this.initDataset = {
      menu: 'scanner',
      submenu: 'scanner__industrial_grade'
    }
    // 移动端显示的临界点
    this.mobileBreakpoint = 1280

    this.init()
  }

  init () {
    const _this = this
    document.addEventListener('DOMContentLoaded', () => {
      this.handleNavToggle()
      this.handleProdMenu()
      this.insertCustomContent()

      this.initMBMenuContent()
      this.initMBMenuToggle()
      this.elProdRight = Array.from(
        document.querySelectorAll('.HNav__prod-right--item')
      )

      this.initMenuToggle()

      this.insertViewAll()
      this.initShowInfo()
    })

    window.addEventListener('load', () => {
      this.handleDiscover()
    })
    window.addEventListener('resize', e => {
      if (e.target.innerWidth > _this.mobileBreakpoint && _this.elMenuClose) {
        // console.log('resize', e, _this.elMenuClose, this, _this)
        _this.elMenuClose.click()
      }
    })
  }

  // 跳转底下区域
  handleDiscover () {
    const elDiscover = document.querySelector('.to-discover')
    elDiscover.addEventListener('click', () => {
      this.elNav.classList.add('HNavClickHide')
      const urlPath = window.location.pathname.split('/').filter(item => item)
      
      // 检查是否为多语言首页
      const isMultiLangHomepage = urlPath.length === 1 && 
        ['fr-fr', 'de-de', 'en-uk', 'en-au', 'en-ca', 'en-eur', 'en-hk'].includes(urlPath[0])
      
      if (urlPath.length === 0 || isMultiLangHomepage) {
        // 首页: "/" 或 "/fr-fr" "/de-de" 等
        jumpToTarget('#HomeDiscover')
      } else {
        // 非首页，需要跳转到对应的首页
        const currentLang = urlPath[0]
        const supportedLangs = ['fr-fr', 'de-de', 'en-uk', 'en-au', 'en-ca', 'en-eur', 'en-hk']
        const origin = supportedLangs.includes(currentLang) ? `/${currentLang}` : '/'
        window.location.href = `${origin}#HomeDiscover`
      }
    })
    
    // 初始加载跳转
    const hash = window.location.hash
    if(hash === '#HomeDiscover') {
      jumpToTarget('#HomeDiscover')
      // 删除 hash，避免页面刷新后重复跳转
      window.history.replaceState({}, '', window.location.pathname + window.location.search)
    }
  }

  // 隐藏所有产品
  hideAllProd () {
    this.elProdRight.forEach(item => {
      item.classList.remove('active')
    })
    this.clearAllSubmenu()
  }

  // 清除所有子项状态
  clearAllSubmenu () {
    this.elProdSubmenu.forEach(item => {
      item.classList.remove('active')
    })
  }

  // 清除所有active状态
  clearAllActive (target) {
    target.forEach(item => {
      item.classList.remove('active')
    })
  }

  // 初始显示：显示初始菜单和子菜单，展开及状态
  initShowInfo () {
    this.handleToggleProd(this.initDataset)
    // 显示产品
    document
      .querySelector(
        `.HNav__prod-sub-item[data-submenu="${this.initDataset['submenu']}"]`
      )
      .classList.add('active')

    // 显示顶部view all
    document
      .querySelector(
        `.HNav__top-handle-item[data-menu="${this.initDataset.menu}"]`
      )
      ?.classList.add('active')
  }

  // 封装通用 产品/自定义内容显示
  handleToggleProd (dataset = {}) {
    if (dataset?.otherUuid) {
      const customContentEl = document.querySelector(
        `.HNav__prod-right--item-custom[data-other-uuid="${dataset.otherUuid}"]`
      )
      customContentEl.classList.add('active')
      return
    }
    const filtedProducts = this.elProdRight.filter(item => {
      if (dataset.submenu) {
        return (
          item.dataset.productMenu === dataset.menu &&
          item.dataset.productSubmenu === dataset.submenu
        )
      } else {
        return item.dataset.productMenu === dataset.menu
      }
    })

    filtedProducts.forEach(item => {
      item.classList.add('active')
    })
  }

  // 产品菜单交互
  handleProdMenu () {
    // 初始显示第一个导航相关的产品

    // 有子菜单则点击显示第一项子项，无子菜单则hover显示所有项
    this.elProdMenu.forEach(item => {
      const menuDataset = item.dataset
      const event = menuDataset.hasSubMenu === 'true' ? 'click' : 'mouseenter'
      item.addEventListener(event, e => {
        const closetLi = e.target.closest('li')
        // 只有点击的是主导航才继续
        if (closetLi !== item) return

        if (menuDataset.hasSubMenu === 'true') {
          console.log(`%c>> ${event}有子菜单11`, 'color:yellow', item)
          // 有子菜单则点击 toggle 所有子项，并始终显示第一项子项,
          // 获取 data-expand-status ，如果open，则更新为close，如果close，则更新为open
          const expandStatus = item.dataset.expandStatus
          item.dataset.expandStatus = expandStatus === 'open' ? 'close' : 'open'

          return
        } else if (menuDataset.hasSubMenu === 'false') {
          // 无子菜单则hover显示所有项
          this.hideAllProd() // 清除所有子项状态
          // 找到 data-product-menu 和 dataset menu 一致的所有元素
          this.handleToggleProd(menuDataset)
        }
      })
    })

    // 鼠标移上显示子菜单
    this.elProdSubmenu.forEach(item => {
      const submenuDataset = item.dataset
      item.addEventListener('mouseenter', () => {
        this.hideAllProd()
        item.classList.add('active')
        this.handleToggleProd(submenuDataset)
      })
    })
  }

  // 定义产品菜单组件
  defineMenuProducts () {
    if (!customElements.get('header-nav-type-products')) {
      customElements.define(
        'header-nav-type-products',
        class MenuDownType extends HTMLElement {
          constructor () {
            super()
            this.init()
          }

          init () {
            console.log('MenuDownType init')
          }
        }
      )
    }
  }

  // 点击关闭按钮关闭，hover时显示
  handleNavToggle () {
    this.elNavClose.forEach(item => {
      item.addEventListener('click', () => {
        console.log('click')
        this.elNav.classList.add('HNavClickHide')
      })
    })

    this.elNav.addEventListener('mouseenter', () => {
      this.elNav.classList.remove('HNavClickHide')
    })
  }

  // 将自定义内容插入到内容显示区
  insertCustomContent () {
    this.elProdSubmenuOther.forEach(item => {
      const customContent = item.dataset.otherContent
      const customContentEl = document.createElement('div')
      customContentEl.classList.add(
        'HNav__prod-right--item',
        'HNav__prod-right--item-custom'
      )
      customContentEl.dataset.productMenu = 'other'
      customContentEl.dataset.otherUuid = item.dataset.otherUuid
      customContentEl.innerHTML = customContent
      this.elProdArea.insertAdjacentElement('beforeend', customContentEl)
    })
  }
  // 将view-all 插入到内容显示区
  insertViewAll () {
    const topHandleContent = document.querySelector('.HNav__top-handle-content')
    // 先清空
    topHandleContent.innerHTML = ''
    this.elProdMenu.forEach(item => {
      const viewAll = item.dataset.viewAll
      if (viewAll) {
        const viewAllEl = document.createElement('div')
        viewAllEl.classList.add('HNav__top-handle-item')
        viewAllEl.dataset.menu = item.dataset.menu
        viewAllEl.innerHTML = viewAll
        // topHandleContent.insertAdjacentElement('beforeend', viewAllEl)
        topHandleContent.append(viewAllEl)
      }

      item.addEventListener('mouseenter', () => {
        document.querySelectorAll('.HNav__top-handle-item').forEach(item => {
          item.classList.remove('active')
        })
        document
          .querySelector(
            `.HNav__top-handle-item[data-menu="${item.dataset.menu}"]`
          )
          ?.classList.add('active')
      })
    })
  }

  initMenuContentTop () {
    const headerNav = document.querySelector('.header-nav-sticky')
    const headerNavRect = headerNav.getBoundingClientRect()
    const headerNavHeight = headerNavRect.height
    const headerNavTop = headerNavRect.top

    const containers = document.querySelectorAll(
      '.HNav__menu-container .HNav__menu-down-content'
    )

    console.log(`%c>> ${headerNavTop}`, 'color:yellow', headerNavTop, headerNavHeight, headerNav)
    containers.forEach(item => {
      item.style.top = `${headerNavTop + headerNavHeight}px`
    })
  }

  // 移动端菜单显示隐藏
  initMenuToggle () {
    this.elMenuOpen.addEventListener('click', () => {
      const headerNav = document.querySelector('.header-nav-sticky')
      const headerNavRect = headerNav.getBoundingClientRect()
      const headerNavHeight = headerNavRect.height
      const headerNavTop = headerNavRect.top

      console.log('click open')
      this.elMenuOpen.classList.remove('active')
      this.elMenuClose.classList.add('active')
      this.elMenuMb.classList.add('active')
      this.elMenuMb.style.top = `${headerNavTop + headerNavHeight}px`
    })
    this.elMenuClose.addEventListener('click', () => {
      console.log('click close')
      this.elMenuOpen.classList.add('active')
      this.elMenuClose.classList.remove('active')
      this.elMenuMb.classList.remove('active')
    })
  }

  // 移动端子菜单初始化
  initMBMenuContent () {
    const prodSubmenuList = [
      'scanner__industrial_grade',
      'scanner__LiDAR',
      'scanner__Portable',
      'scanner__Standalone',
      'scanner__Trackit'
    ]
    prodSubmenuList.forEach(item => {
      const targetEl = document.querySelector(`#HNavMBProd__${item}`)
      const sourceEl = document.querySelectorAll(
        `[data-product-submenu="${item}"]`
      )
      if (targetEl && sourceEl) {
        targetEl.innerHTML = ''
        this.copyNodeToTarget(targetEl, sourceEl)
      }
    })
    const prodMap = [
      {
        type: 'software',
        el: '[data-product-menu="software"]'
      },
      {
        type: 'accessory',
        el: '[data-product-menu="accessory"]'
      }
    ]
    prodMap.forEach(item => {
      const targetEl = document.querySelector(`#HNavMBProd__${item.type}`)
      const sourceEl = document.querySelectorAll(item.el)
      if (targetEl && sourceEl) {
        targetEl.innerHTML = ''
        this.copyNodeToTarget(targetEl, sourceEl)
      }
    })

    const elMap = [
      { type: 'applications', el: '.HNav__applications--left' },
      { type: 'support', el: '[data-card-type="support"]' },
      { type: 'community', el: '[data-card-type="community"]' },
      { type: 'about_us', el: '.HNav__dropdown--about-us' }
    ]

    elMap.forEach(item => {
      const el = document.querySelector(`#HNavMB__${item.type}`)
      const elContent = document.querySelectorAll(item.el)

      if (el && elContent) {
        el.innerHTML = ''
        this.copyNodeToTarget(el, elContent)
      }
    })
  }

  closeAllMBMenu () {
    const elMenuWrapper = document.querySelectorAll('.HNavMB__menu-item')
    elMenuWrapper.forEach(item => {
      item.dataset.toggleStatus = 'close'
    })
  }

  closeAllMBSubMenu () {
    const elSubMenuWrapper = document.querySelectorAll('.HNavMB__sub-menu-item')
    elSubMenuWrapper.forEach(item => {
      item.dataset.toggleStatus = 'close'
    })
  }

  // 清空所有active状态， 关闭所有子菜单
  closeAllMBToggle (target) {
    target.forEach(item => {
      item.dataset.toggleStatus = 'close'
    })
  }

  initMBMenuToggle () {
    this.elToggleLabel.forEach(item => {
      item.addEventListener('click', () => {
        const elToggleWrapper = item.closest('.HNav__toggle')
        // 找到 elToggleWrapper 所有兄弟元素 并清空active状态
        const elToggleWrapperList =
          elToggleWrapper.parentElement.querySelectorAll('.HNav__toggle')

        const elToggleStatus = elToggleWrapper.dataset.toggleStatus
        const isOpen = elToggleWrapper.dataset.toggleStatus === 'open'
        console.log(`%c>> ${elToggleStatus}`, 'color:yellow', item)
        // if (!isOpen) {
        //   this.closeAllMBToggle(elToggleWrapperList)
        // }
        elToggleWrapper.dataset.toggleStatus =
          elToggleStatus === 'open' ? 'close' : 'open'
      })
    })
  }

  /**
   * 保留目标节点，将目标节点复制到指定容器;
   * 1. 用文档碎片，优化性能
   * 2. 保留原来的节点不被移动
   * @param {HTMLElement} container 目标容器，是空的
   * @param {HTMLElement|NodeList} source 源节点： 需要复制的节点,；可能是单个节点,如：document.querySelector('xxx')，也可以是节点列表，如：document.querySelectorAll('xxx')，注意去重;
   */

  copyNodeToTarget (container, sourceNode) {
    if (!container || !sourceNode) return

    // 统一转成数组
    const nodes = []
    if (sourceNode instanceof Element) {
      nodes.push(sourceNode)
    } else if (
      sourceNode instanceof NodeList ||
      sourceNode instanceof HTMLCollection
    ) {
      nodes.push(...sourceNode)
    } else {
      // 打印类型
      console.log(
        `%c>> $其他类型`,
        'color:yellow',
        sourceNode,
        typeof sourceNode
      )
    }

    // 去重
    const uniqueNodes = nodes.filter(
      (item, index, self) => index === self.findIndex(t => t.isEqualNode(item))
    )

    const fragment = document.createDocumentFragment()

    uniqueNodes.forEach(item => {
      const cloneNode = item.cloneNode(true)
      fragment.appendChild(cloneNode)
    })
    container.append(fragment)
  }
}

new HeaderNav()

function updateCountrySelect (element) {
  var currentURL = window.location.href
  console.log('Current URL:', currentURL)

  if (currentURL.includes('https://global.revopoint3d.com/fr-fr')) {
    element.innerHTML =
      '<div class="flag flag-fr"></div><span lang="en">France</span>'
  } else if (currentURL.includes('https://global.revopoint3d.com/de-de')) {
    element.innerHTML =
      '<div class="flag flag-de"></div><span lang="en">DE</span>'
  } else if (currentURL.includes('https://global.revopoint3d.com/en-uk')) {
    element.innerHTML =
      '<div class="flag flag-uk"></div><span lang="en">UK</span>'
  } else if (currentURL.includes('https://global.revopoint3d.com/en-ca')) {
    element.innerHTML =
      '<div class="flag flag-ca"></div><span lang="en">Canada</span>'
  } else if (currentURL.includes('https://global.revopoint3d.com/en-hk')) {
    element.innerHTML =
      '<div class="flag flag-hk"></div><span lang="en">Hong Kong SAR</span>'
  } else if (currentURL.includes('https://global.revopoint3d.com/en-au')) {
    element.innerHTML =
      '<div class="flag flag-au"></div><span lang="en">Australia</span>'
  } else if (currentURL.includes('https://global.revopoint3d.com/en-eur')) {
    element.innerHTML =
      '<div class="flag flag-eu"></div><span lang="en">Europe</span>'
  } else if (currentURL.includes('https://www.revopoint3d.com')) {
    element.innerHTML =
      '<div class="flag flag-usa"></div><span lang="en">USA</span>'
  } else if (currentURL.includes('https://www.revopoint3d.jp/')) {
    element.innerHTML =
      '<div class="flag flag-ja"></div><span lang="en">Japan</span>'
  } else {
    element.innerHTML =
      '<div class="flag flag-global"></div><span lang="en">Global</span>'
  }
}

document.addEventListener('DOMContentLoaded', function () {
  var countrySelectElements = [
    document.getElementById('countryselect'),
    document.getElementById('countryselect1')
  ]

  countrySelectElements.forEach(function (element) {
    if (element) {
      updateCountrySelect(element)
    }
  })
})

function layer_country () {
  layer.open({
    type: 1,
    title:
      '<div class="countrylist-title"><h3>Select Your Country/Region</h3></div>',
    area: ['auto', 'auto'],
    shadeClose: true, // 点击遮罩区域，关闭弹层
    content: ` 
        <div class="countrylist">
          <div class="country-item">
            <div class="country-title">
              <p>North America</p>
            </div>
            <div class="country-select">
              <a href="https://www.revopoint3d.com/?ref=selecter" ><li><span class="countrylist--desc">United States</span><span class="countrylist--lang">English/$USD</span></li></a>
              <a href="https://global.revopoint3d.com/en-ca?ref=selecter"><li><span class="countrylist--desc">Canada</span><span class="countrylist--lang">English/$CAD</span></li></a>
            </div>
          </div>
          <div class="country-item">
            <div class="country-title">
              <p>Europe</p>
            </div>
            <div class="country-select">
              <a href="https://global.revopoint3d.com/en-uk?ref=selecter"><li><span class="countrylist--desc">United Kingdom</span><span class="countrylist--lang">English/£GBP</span></li></a>
              <a href="https://global.revopoint3d.com/fr-fr?ref=selecter"><li><span class="countrylist--desc">France</span><span class="countrylist--lang">Français/€EUR</span></li></a>
              <a href="https://global.revopoint3d.com/de-de?ref=selecter"><li><span class="countrylist--desc">Deutschland</span><span class="countrylist--lang">Deutsch/€EUR</span></li></a>
              <a href="https://global.revopoint3d.com/en-eur?ref=selecter"><li><span class="countrylist--desc">Europe</span><span class="countrylist--lang">English/€EUR</span></li></a>
            </div>
          </div>
          <div class="country-item">
            <div class="country-title">
              <p>Asia Pacific</p>
            </div>
            <div class="country-select">
            <a href="https://global.revopoint3d.com/en-au?ref=selecter"><li><span class="countrylist--desc">Australia</span><span class="countrylist--lang">English/$AUD</span></li></a>
            <a href="https://www.revopoint3d.com.cn"><li><span class="countrylist--desc">中国大陆</span><span class="countrylist--lang">中文 / ¥ CNY</span></li></a>
            <a href="https://global.revopoint3d.com/en-hk?ref=selecter"><li><span class="countrylist--desc">Hong Kong SAR</span><span class="countrylist--lang">English/$USD</span></li></a>
              <a href="https://tw.revopoint3d.com"><li><span class="countrylist--desc">中國台灣</span><span class="countrylist--lang">繁體中文 / NT $</span></li></a>
              <a href="https://www.revopoint3d.jp/?ref=selecter"><li><span class="countrylist--desc">日本</span><span class="countrylist--lang">日本語/¥JPY</span></li></a>
            </div>
          </div>
          <div class="country-item">
            <div class="country-title">
              <p>Other Countries and Regions</p>
            </div>
            <div class="country-select">
              <a href="https://global.revopoint3d.com/?ref=selecter"><li><span class="countrylist--desc">Global</span><span class="countrylist--lang">English / $ USD</span></li></a>
            </div>
          </div>
        </div>`
  })
}

// start: locountry.js
const presetCountries = ['GLOBAL']

// 'https://api.ipdata.co/?api-key=f3ec9a1cee61dbb4204c48020f7c4c8d4d8a85018426c5d5ebc36c7d'
async function getCountryFromIP () {
  try {
    const response = await fetch(
      'https://ipdata.revopoint3d.com'
    )
    const data = await response.json()
    return { country: data.country_code, isEU: data.is_eu }
  } catch (error) {
    return { country: null, isEU: null }
  }
}

function recommendLinkByCountry (country, isEU) {
  const countrySelect = document.getElementById('countrySelect')
  const countrySelectContainer = document.getElementById(
    'countrySelectContainer'
  )
  const countrySelectPC = document.getElementById('countrySelectPC')
  const countrySelectMob = document.getElementById('countrySelectMob')
  const continueBtn = document.getElementById('continueBtn')
  const langs = {
    EN: {
      titlePc:
        'Please select the country or region most appropriate for your location.',
      titleMob:
        'Please select the country or region most appropriate for your location.',
      btn: 'Continue',
      others: 'Others'
    },
    FR: {
      titlePc:
        'Veuillez sélectionner le pays ou la région qui correspond le mieux à votre emplacement.',
      titleMob: 'Sélectionnez votre pays ou région.',
      btn: 'Continuer',
      others: 'Autres'
    },
    DE: {
      titlePc:
        'Bitte wählen Sie das Land oder die Region aus, die am besten zu Ihrem Standort passt.',
      titleMob: 'Wählen Sie Ihr Land oder Ihre Region aus.',
      btn: 'Fortfahren',
      others: 'Andere'
    },
    JP: {
      titlePc: 'お住まいの地域に最も適した国または地域を選択してください。',
      titleMob: '国または地域を選択してください',
      btn: '続ける',
      others: 'その他'
    }
  }
  const countryOptions = {
    US: { url: 'https://www.revopoint3d.com/', name: 'United States' },
    GB: { url: 'https://global.revopoint3d.com/en-uk', name: 'United Kingdom' },
    FR: { url: 'https://global.revopoint3d.com/fr-fr', name: 'France' },
    DE: { url: 'https://global.revopoint3d.com/de-de', name: 'Deutschland' },
    JP: { url: 'https://www.revopoint3d.jp/', name: '日本' },
    TW: { url: 'https://tw.revopoint3d.com/', name: 'Taiwan' },
    EU: { url: 'https://global.revopoint3d.com/en-eur', name: 'Europe' },
    HK: { url: 'https://global.revopoint3d.com/en-hk', name: 'Hong Kong SAR' },
    AU: { url: 'https://global.revopoint3d.com/en-au', name: 'Australia' },
    CA: { url: 'https://global.revopoint3d.com/en-ca', name: 'Canada' },
    GLOBAL: { url: 'https://global.revopoint3d.com/', name: 'Global' }
  }

  countrySelect.innerHTML = ''

  let selectedCountryUrl = countryOptions['GLOBAL'].url
  let selectedCountryName = countryOptions['GLOBAL'].name

  if (countryOptions[country]) {
    selectedCountryUrl = countryOptions[country].url
    selectedCountryName = countryOptions[country].name
    // 20241204 不同语言
    countrySelectPC.innerHTML = langs?.[country]?.titlePc || langs.EN.titlePc
    countrySelectMob.innerHTML = langs?.[country]?.titleMob || langs.EN.titleMob
    continueBtn.innerHTML = langs?.[country]?.btn || langs.EN.btn
  } else if (isEU) {
    selectedCountryUrl = countryOptions['EU'].url
    selectedCountryName = countryOptions['EU'].name
  }

  countrySelect.innerHTML = `
    <option value="${selectedCountryUrl}">${selectedCountryName}</option>
    <option value="__others__">${(langs[country] || langs.EN).others}</option>
  `

  const currentUrl = window.location.href
  const isPresetCountry = presetCountries.includes(country)
  const isCurrentUrlSameAsSelectedCountryUrl =
    currentUrl.startsWith(selectedCountryUrl)

  // 根据设备类型设置显示方式
  if (!isPresetCountry && !isCurrentUrlSameAsSelectedCountryUrl) {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent)
    countrySelectContainer.style.display = isMobile ? 'block' : 'flex'
  } else {
    countrySelectContainer.style.display = 'none'
  }
}

window.onload = async function () {
  const countrySelectContainer = document.getElementById(
    'countrySelectContainer'
  )
  countrySelectContainer.style.display = 'none'

  const lastActionTime = localStorage.getItem('lastActionTime')
  const currentTime = Date.now()

  // console.log(`%c>> $`, 'color:yellow', currentTime,    lastActionTime)

  if (
    !lastActionTime ||
    currentTime - lastActionTime > 14 * 24 * 60 * 60 * 1000
  ) {
    const { country, isEU } = await getCountryFromIP()
    recommendLinkByCountry(country, isEU)
  }

  document.getElementById('continueBtn').addEventListener('click', function () {
    const countrySelect = document.getElementById('countrySelect')
    if (countrySelect.value === '__others__') {
      if (typeof layer_country === 'function') layer_country()
      return
    }
    window.location.href = countrySelect.value
    localStorage.setItem('lastActionTime', Date.now().toString())
    countrySelectContainer.style.display = 'none'
  })

  document.getElementById('countrySelect').addEventListener('change', function () {
    if (this.value !== '__others__') return
    const recommended = this.querySelector('option:not([value="__others__"])')
    if (recommended) this.value = recommended.value
    if (typeof layer_country === 'function') layer_country()
  })

  document.querySelectorAll('.closepc, .closemb').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      countrySelectContainer.style.display = 'none'
      localStorage.setItem('lastActionTime', Date.now().toString())
    })
  })
}
